
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './nahal-ui-wasm-js.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
wasmLastStatus,
wasmLastBody,
wasmHeaderSet,
wasmHeadersClear,
wasmGet,
wasmPost,
wasmPatch,
wasmDelete,
wasmPostFile,
wasmPartAdd,
wasmPartsClear,
wasmPostMultipart,
wasmVarsReset,
wasmVarsSet,
wasmVarsAdd,
wasmExpandVars,
wasmClose,
memory,
_initialize
} = exports


